// @flow weak

import React            from 'react';
import PropTypes        from 'prop-types';
import {
  Motion,
  spring
}                       from 'react-motion';
import { Link }         from 'react-router-dom';

const MenuHeader = ({

  title,
  linkTo, 
  viewName,  
  faIconName,
  bakColor,
  isCollapsed,
  onClick
}) =>

(
  
      <a className="btn" onClick={onClick} >
       <i className="fa fa-eye fa-1x pull-left" style={{lineHeight: '18px'}}></i>
        <span className="pull-left sidebar-menu__group-title" style={{fontSize: '13px',marginLeft: '5px'}}>

          {title}
        </span>
        <i className={isCollapsed ? 'fa fa-angle-up fa-1x pull-right' : 'fa fa-angle-down fa-1x pull-right' } style={{lineHeight: '18px'}}></i>
      </a>
    
);

MenuHeader.propTypes = {
  backColor:    PropTypes.string.isRequired,
  title:        PropTypes.string.isRequired,
  isCollapsed:  PropTypes.bool.isRequired,
  onClick:      PropTypes.func.isRequired
};

export default MenuHeader;


// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/menu/menuHeader/MenuHeader.js